export const SET_SERVICES_REQUIRING_PROOFING = 'SET_SERVICES_REQUIRING_PROOFING';
export const SET_PENDING_SCHEDULE_REQUESTS = 'SET_PENDING_SCHEDULE_REQUESTS';
